import React, { useRef, useState } from "react";
import { Styles } from "./styles";
import { Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const VedioPlayer = ({ video, thumbnail, isLoading }) => {
  // Ahmad states
  const [videoURL, setVideoURL] = useState("");
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);

  const { t, i18n } = useTranslation();
  const isAr = i18n.language === "ar";
  const [show, setShow] = useState(false);
  const [isCopied, setIsCopied] = useState("copy");
  const target = useRef(null);
  const handleCopy = () => {
    navigator.clipboard.writeText(window.location.href);
    setIsCopied("copied");
  };
  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {isCopied == "copy"
        ? Resource?.copy_link
          ? Resource?.copy_link
          : t("lesson.copy_url")
        : Resource?.copied_link
        ? Resource?.copied_link
        : t("lesson.copied_url")}
    </Tooltip>
  );

  return (
    <Styles isLoading={isLoading}>
      <div className="video-container" id="videoContainer">
        <iframe
          id="iframe"
          src={video}
          // "https://iframe.mediadelivery.net/embed/226297/ba05266e-cdbb-4655-91c9-792ac18eee62"
          loading="lazy"
          allow="accelerometer;gyroscope;encrypted-media;picture-in-picture;"
          allowfullscreen="true"
          width="1920"
          height="720"
        ></iframe>
      </div>
    </Styles>
  );
};

export default VedioPlayer;
